import { getShopNameFromToken } from "../../utils/jwtUtils";
import { getShopifyAdminAppUrl } from "../../services/CONSTANTS";

/**
 * Shown instead of the app when it's loaded outside the Shopify Admin iframe
 * (see utils/embeddedAppUtils.isRunningStandalone). Renders before App Bridge init
 * or any /api call is made, since none of those are meaningful outside the iframe.
 */
const LegacyStandaloneNotice = () => {
  const params = new URLSearchParams(window.location.search);
  let shopName = params.get("shop");

  if (!shopName) {
    // Best-effort recovery from a leftover pre-cutover JWT, if the browser still has one cached.
    try {
      const legacyTokens = JSON.parse(localStorage.getItem("authTokens") || "null");
      shopName = legacyTokens?.access_token
        ? getShopNameFromToken(legacyTokens.access_token)
        : null;
    } catch (error) {
      shopName = null;
    }
  }

  const openInAdminUrl = getShopifyAdminAppUrl(shopName);

  return (
    <div
      style={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        height: "100vh",
        padding: 24,
        textAlign: "center",
      }}
    >
      <div style={{ maxWidth: 480 }}>
        <h2>Please reopen this app from your Shopify Admin</h2>
        <p>
          This app now runs inside your Shopify Admin. Please reopen it from your
          Shopify Admin dashboard to continue.
        </p>
        {openInAdminUrl ? (
          <a href={openInAdminUrl} target="_top" rel="noopener noreferrer">
            <button style={{ marginTop: 16, padding: "10px 20px", cursor: "pointer" }}>
              Open in Shopify Admin
            </button>
          </a>
        ) : (
          <p>Open the "Inventory Forecast Hero" app from your Shopify Admin app list.</p>
        )}
      </div>
    </div>
  );
};

export default LegacyStandaloneNotice;
